var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-avatar",style:({'background-image':("url(" + _vm._src + ")")})},[(_vm.to)?_c('RouterLink',{staticClass:"ws-avatar__link",attrs:{"to":_vm.to}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }